import { render, staticRenderFns } from "./LoadSession.vue?vue&type=template&id=5c8c06f4"
import script from "./LoadSession.vue?vue&type=script&lang=js"
export * from "./LoadSession.vue?vue&type=script&lang=js"
import style0 from "./LoadSession.vue?vue&type=style&index=0&id=5c8c06f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports